import { GendersList } from '@gtpl/shared-models/gtpl';
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { BloodGroupEntity } from '../bloodgroup/blood-group.entity';
import { HamletEntity } from '../hamlet/hamlet.entity';
import { MandalEntity } from '../mandal/mandal.entity';
import { UserEntity } from '../user/user.entity';
import { VillageEntity } from '../village/village.entity';
import { WardsEntity } from '../wards/wards.entity';

@Entity('profile')
export class ProfileEntity {
  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number;
  @Column("varchar",{
    nullable:false,
    length:10,
    name:"mobile_no"
  })
  mobileNo:string;
  @Column("varchar",{
    nullable: false,
    length:500,
    name:"first_name"
  })
  firstName:string;
  @Column("varchar",{
    nullable: true,
    length:500,
    name:"last_name"
  })
  lastName:string;
  @Column({
    type:'enum',
    nullable: true,
    enum:GendersList,
    default:GendersList.MALE,
    name:"gender"
  })
  gender:GendersList;
  @Column({
    nullable:true,
    name: "dob",
    type:'date'
  })
  dob: Date;
  @Column("varchar",{
    nullable: true,
    length:500,
    name:"address"
  })
  address:string;
  @Column("int",{
    nullable:true,
    name:'wardno_id'
  })
  wardnoId:number;
  @Column("varchar",{
    nullable:true,
    length:500,
    name:'house_number'
  })
  houseNumber:string;
  @Column("int",{
    nullable:true,
    name:'mandal_id'
  })
  mandalId:number;
  @Column("int",{
    nullable: true,
    name:"village_id"
  })
  villageId?:number;
  @Column("int",{
    nullable: true,
    name:"hamlet_id"
  })
  hamletId?:number;
  @Column("varchar",{
    nullable: true,
    name:"email"
  })
  email:string;
  @Column("varchar",{
    nullable: true,
    length:500,
    name:"profile_pic"
  })
  profilePic:string;
  @Column("boolean",{
    nullable:false,
    default:false,
    name:"blood_donner"  
  })
  BloodDonner:boolean;
  @Column("int",{
    nullable:true,
    name:"bgroup_id"
  })
  BGroupId:number;  
  @Column("varchar",{
    nullable:true,
    length:500,
    name:"membership_img"
  })  
  membershipImg:string;
  @Column("int",{
    nullable: false,
    name:"user_id"
  })
  userId:number;
  @Column("boolean",{
    nullable:false,
    default:true,               
    name:"status" 
  })
  status:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;
  @UpdateDateColumn({
    name: "updated_at",
    type:'datetime'
  })
  updatedAt: Date;
  @VersionColumn({
    default:1,
    name: "version_flag"
  })
  versionFlag: number;

  @OneToOne(() => UserEntity, (user: UserEntity) => user.profile)
  @JoinColumn({ name: 'user_id' })
  user: UserEntity;
   
  @ManyToOne(() => VillageEntity, (village:VillageEntity) => village.profile)
  @JoinColumn({name:"village_id"})
  village:VillageEntity;

  @ManyToOne(() => BloodGroupEntity, (bgroup:BloodGroupEntity) => bgroup.profile)
  @JoinColumn({name:"bgroup_id"})
  bgroup:BloodGroupEntity;

  @ManyToOne(() => WardsEntity, (ward:WardsEntity) => ward.profile,{nullable:true})
  @JoinColumn({name:"wardno_id"})
  ward:WardsEntity;

  @ManyToOne(() => HamletEntity, (hamlet:HamletEntity) => hamlet.profile,{nullable:true})
  @JoinColumn({name:"hamlet_id"})
  hamlet:HamletEntity;

  @ManyToOne(() => MandalEntity, (mandal:MandalEntity) => mandal.profile,{nullable:true})
  @JoinColumn({name:'mandal_id'})
  mandal:MandalEntity;
}

